<script setup lang="ts">
interface SmallCardProp {
    content?: string;
    withBorder?: boolean;
}

const props = withDefaults(defineProps<SmallCardProp>(), {
    content: "",
    withBorder: true,
});
</script>

<template>
    <VFlex
        flex-direction="row"
        justify-content="center"
        align-items="center"
        class="has-gradient-background-ttb has-border-radius option p-5 has-text-centered"
        :class="{ 'has-border-primary': props.withBorder }">
        <slot>
            <span
                class="is-size-5 has-text-white is-uppercase has-text-weight-bold"
                style="word-wrap: break-word">
                {{ props.content }}
            </span>
        </slot>
    </VFlex>
</template>

<style lang="scss" scoped>
.option {
    background: radial-gradient(circle, $dark 0%, $blue 100%);
    background-size: 200% 200%;
    animation: gradient 20s ease infinite;

    &:nth-child(1) {
        animation-delay: 0.25s;
    }

    &:nth-child(2) {
        animation-delay: 0.5s;
    }
}
</style>